var React = require('react');

function CalendarLast (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M206.78-60.78q-44.3 0-75.15-30.85-30.85-30.85-30.85-75.15v-546.44q0-44.3 30.85-75.15 30.85-30.85 75.15-30.85H240v-80h93v80h294v-80h93v80h33.22q44.3 0 75.15 30.85 30.85 30.85 30.85 75.15v189.83h-106V-560H206.78v393.22h269.83v106H206.78Zm0-579.22h546.44v-73.22H206.78V-640Zm0 0v-73.22V-640ZM556.61-60.78v-138.83L781-423q10.7-10.8 23.77-15.59 13.07-4.8 26.14-4.8 14.26 0 27.27 5.35 13.01 5.34 23.65 16.04l37 37q9.59 10.7 14.99 23.77t5.4 26.14q0 13.83-4.85 27.03-4.85 13.19-15.54 23.89L695.44-60.78H556.61Zm311.3-274.31-37-37 37 37Zm-240 203h38l118.74-119.74-18-19-19-18-119.74 118.74v38Zm138.74-138.74-19-18 37 37-18-19Z"}));
}

CalendarLast.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = CalendarLast;

CalendarLast.default = CalendarLast;
